import createIcon from '../../createIcon';

/**
 * @component @name BackHand
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuMjUxMiAyNEM5Ljk5MTIgMjQgNy4wNjEyIDIyLjAxIDUuODUxMiAxOC45OEwyLjgyMTIgMTEuMzdDMi41MTEyIDEwLjU4IDMuMjUxMiA5Ljc5IDQuMDYxMiAxMC4wNUw0Ljg1MTIgMTAuMzFDNS40MTEyIDEwLjQ5IDUuODcxMiAxMC45MiA2LjA5MTIgMTEuNDdMNy41MDEyIDE1SDguMjUxMlYzLjI1QzguMjUxMiAyLjU2IDguODExMiAyIDkuNTAxMiAyQzEwLjE5MTIgMiAxMC43NTEyIDIuNTYgMTAuNzUxMiAzLjI1VjEySDExLjc1MTJWMS4yNUMxMS43NTEyIDAuNTYgMTIuMzExMiAwIDEzLjAwMTIgMEMxMy42OTEyIDAgMTQuMjUxMiAwLjU2IDE0LjI1MTIgMS4yNVYxMkgxNS4yNTEyVjIuNzVDMTUuMjUxMiAyLjA2IDE1LjgxMTIgMS41IDE2LjUwMTIgMS41QzE3LjE5MTIgMS41IDE3Ljc1MTIgMi4wNiAxNy43NTEyIDIuNzVWMTJIMTguNzUxMlY1Ljc1QzE4Ljc1MTIgNS4wNiAxOS4zMTEyIDQuNSAyMC4wMDEyIDQuNUMyMC42OTEyIDQuNSAyMS4yNTEyIDUuMDYgMjEuMjUxMiA1Ljc1VjE2QzIxLjI1MTIgMjAuNDIgMTcuNjcxMiAyNCAxMy4yNTEyIDI0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BackHand = createIcon('BackHand', [
  [
    'path',
    {
      d: 'M13.2512 24C9.9912 24 7.0612 22.01 5.8512 18.98L2.8212 11.37C2.5112 10.58 3.2512 9.79 4.0612 10.05L4.8512 10.31C5.4112 10.49 5.8712 10.92 6.0912 11.47L7.5012 15H8.2512V3.25C8.2512 2.56 8.8112 2 9.5012 2C10.1912 2 10.7512 2.56 10.7512 3.25V12H11.7512V1.25C11.7512 0.56 12.3112 0 13.0012 0C13.6912 0 14.2512 0.56 14.2512 1.25V12H15.2512V2.75C15.2512 2.06 15.8112 1.5 16.5012 1.5C17.1912 1.5 17.7512 2.06 17.7512 2.75V12H18.7512V5.75C18.7512 5.06 19.3112 4.5 20.0012 4.5C20.6912 4.5 21.2512 5.06 21.2512 5.75V16C21.2512 20.42 17.6712 24 13.2512 24Z',
      key: 'aq6prh',
    },
  ],
]);

export default BackHand;
